import { SalesforceCloud } from '../constants/salesforce.constants'
import { parseJsonSafe } from './general-helpers'

export const getODMAccessEnabledClouds = (): SalesforceCloud[] => {
  const odmAccessEnabledClouds = parseJsonSafe(process.env.ENABLE_ODM_ACCESS_PAGE)
  return odmAccessEnabledClouds || []
}
